'use client';

import { useParams } from 'next/navigation';
import React, { FC, useState } from 'react';

import { NewsType } from '@/api/config/types';
import GlobalService from '@/api/services/GlobalService';
import { ListResponse } from '@/api/types';
// import { NEWS_ROUTE } from '@/app/[lang]/Router/routes';
import { NEWS_ROUTE } from '@/app/[lang]/Router/routes';
import Link from '@/components/core/Link';
import Pagination from '@/components/Pagination';
import { useTranslation } from '@/hooks/useTranslations';

import NewsItem from './NewsItem';
import NewsList from './NewsList';

import './styles.scss';

interface NewsProps {
  title?: string;
  limit?: number;
  isNewsPage?: boolean;
  exploreMore?: boolean;
  innerClassName?: string;
  hidePagination?: boolean;
  newsList: ListResponse<NewsType>;
}

const News: FC<NewsProps> = ({
  limit,
  newsList,
  exploreMore,
  title = 'Homepage-title-News',
  hidePagination,
  isNewsPage,
}) => {
  const [newsData, setNewsData] = useState(newsList.query);

  const params = useParams();
  const { t } = useTranslation();

  const onPageChange = async (page: number) => {
    return await GlobalService.getData<NewsType>('NEWS_URL_FRONT', {
      page,
      perPage: 9,
      category: '',
      lang: params.lang,
    }).then((response) => setNewsData(response.query));
  };

  return (
    <div className="new-section-container-holder" id="news">
      <div className="bigContent">
        <div className={'newsBigContWrp'}>
          <div className="news-wrapper">
            <div className="news-title">
              {isNewsPage ? (
                <h1 className="newsTitleText">{t(title)}</h1>
              ) : (
                <h2 className="newsTitleText">{t(title)}</h2>
              )}
            </div>
            {exploreMore && (
              <div className="news-button-cont">
                <div className="news-button-row">
                  <Link
                    href={NEWS_ROUTE.getPath(params.lang as string)}
                    className="button btnTypeMedium btnTypeGray"
                  >
                    <p className="mobBtnTxt">{t('Explore more-Button')}</p>
                    <i className="bc-i-go-to btnIcon btnIconSmall" />
                  </Link>
                </div>
              </div>
            )}
            <NewsList>
              {newsData.slice(0, limit).map((item) => (
                <NewsItem {...item} logo={item.thumbnails} key={item.id} />
              ))}
            </NewsList>
          </div>
          {hidePagination && (
            <Pagination
              pageSize={9}
              hideOnSinglePage={true}
              onChange={onPageChange}
              total={newsList.totalCount}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default News;
